import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { Employee } from '../../model/employee';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [AuthenticationService]
})
export class LoginComponent implements OnInit {

  email: string;
  password: string;

  loading: boolean;

  errorMessage: string;

  constructor(private authService: AuthenticationService, private router: Router) {
    this.loading = false;
  }

  ngOnInit() {
  }

  login() {
    this.startLogin();

    this.authService.loginWithCredentials(this.email, this.password)
      .then(() => this.goToHome())
      .catch(error => this.loginError(error));
  }

  private loginError(error) {
    console.log(error);

    this.loading = false;
    this.errorMessage = error;
    this.password = '';
  }

  private startLogin() {
    delete this.errorMessage;
    this.loading = true;
  }

  private goToHome() {
    this.router.navigate(['/home']);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts